import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { DirectCarrierRegistration } from '@shipstation/connections-ui/direct';
import { noop } from 'ui-components/default-props/noop';

import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';

export const CuiProviderRegistration = ({
  providerApiCode,
  providerType,
  onBack = noop,
  onRegisterSuccess = noop,
  onRegisterFailure = noop,
  onError = noop,
  onCancel = noop,
}) => {
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const contextProps = useMemo(
    () => ({
      ...cuiContextProps,
      onBack,
      onCancel,
      onError,
      onRegisterFailure,
      onRegisterSubmitRedirectForm: onRegisterSuccess, // used by canada post
      onRegisterSuccess,
    }),
    [cuiContextProps, onBack, onCancel, onError, onRegisterFailure, onRegisterSuccess],
  );

  return (
    <DirectCarrierRegistration
      apiConfig={cuiApiConfig}
      contextProps={contextProps}
      providerApiCode={providerApiCode}
      providerType={providerType}
    />
  );
};

CuiProviderRegistration.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  providerType: PropTypes.string.isRequired,
  onRegisterSuccess: PropTypes.func,
  onRegisterFailure: PropTypes.func,
  onBack: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
